var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Utils, CustomElementUtils, Components, UI as CoreUI } from '@pacem/pacem-core';
import { Components as UIPkgComponents } from '@pacem/pacem-ui';
import { PacemBaseCellElement } from './types';
const UI = UIPkgComponents.UI;
//namespace Pacem.Components.Plus {
export const DataColumnSortEventName = "datacolumnsort";
export class DataColumnSortEvent extends CustomEvent {
    constructor(detail) {
        super(DataColumnSortEventName, { detail, bubbles: false, cancelable: true });
    }
}
export const DataColumnRescaleEventName = "datacolumnrescale";
export class DataColumnRescaleEvent extends CustomEvent {
    constructor(detail) {
        super(DataColumnRescaleEventName, { detail, bubbles: false, cancelable: true });
    }
}
let PacemHeadCellElement = class PacemHeadCellElement extends PacemBaseCellElement {
    constructor(_md = new UI.MarkdownService()) {
        super();
        this._md = _md;
        //#region sort button
        this._sortButtonClickHandler = (evt) => {
            const metadata = this.metadata, gridState = this.gridState, column = metadata.prop;
            const dir = gridState.sort?.column === column ? (gridState.sort.dir === 'desc' ? 'asc' : 'desc') : (metadata.defaultSort || 'asc');
            this.dispatchEvent(new DataColumnSortEvent({ column, dir }));
        };
        this._rescaleHandler = (evt) => {
            evt.preventDefault();
            const detail = evt.detail;
            const width = Math.max(this.metadata.minPixelWidth ?? 24, detail.currentPosition.x - this._columnBBox.x);
            this.dispatchEvent(new DataColumnRescaleEvent({ width }));
        };
        this._rescaleStartHandler = (evt) => {
            this._columnBBox = Utils.offsetRect(this);
        };
        this._rescaleEndHandler = (evt) => {
            // nothing(?)
        };
    }
    connectedCallback() {
        super.connectedCallback();
        Utils.addClass(this, PCSS + '-headcell');
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first && name === 'gridState') {
            this._updateSortButtonIconGlyph();
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._ensureBalloon();
    }
    disconnectedCallback() {
        this._disposeBalloon();
        this._disposeRescaler();
        super.disconnectedCallback();
    }
    updateLayout(metadata = this.metadata) {
        this._setup(metadata);
    }
    _setupSortButton() {
        const btn = new UI.PacemButtonElement();
        btn.className = `button-flat headcell-sort ${PCSS}-inert`;
        this.addEventListener('click', this._sortButtonClickHandler, false);
        Utils.addClass(this, PCSS + '-clickable');
        return btn;
    }
    _disposeSortButton(btn = this._sortButton) {
        if (Utils.isNull(btn)) {
            return;
        }
        Utils.removeClass(this, PCSS + '-clickable');
        this.removeEventListener('click', this._sortButtonClickHandler, false);
        btn.remove();
        this._sortButton = null;
    }
    _updateSortButtonIconGlyph(btn = this._sortButton, state = this.gridState, metadata = this.metadata) {
        if (Utils.isNull(btn) || Utils.isNullOrEmpty(metadata)) {
            return;
        }
        btn.iconGlyph = state?.sort?.column === metadata.prop ? (state.sort.dir === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up') : '';
    }
    _ensureRescaler() {
        if (Utils.isNull(this._rescaler)) {
            const r = this._rescaler = this._rescaler || new Components.PacemRescaleElement();
            r.handles = [CoreUI.RescaleHandle.Right];
            r.addEventListener(CoreUI.RescaleEventType.Rescale, this._rescaleHandler, false);
            r.addEventListener(CoreUI.RescaleEventType.Start, this._rescaleStartHandler, false);
            r.addEventListener(CoreUI.RescaleEventType.End, this._rescaleEndHandler, false);
            CustomElementUtils.findAncestorShell(this).appendChild(r);
        }
    }
    _setupRescaleContainer() {
        this._ensureRescaler();
        const c = new Components.PacemPanelElement();
        c.className = "headcell-rescale";
        c.behaviors = [this._rescaler];
        return c;
    }
    _disposeRescaleContainer(c = this._rescaleContainer) {
        if (Utils.isNull(c)) {
            return;
        }
        c.remove();
        this._rescaleContainer = null;
    }
    _disposeRescaler(r = this._rescaler) {
        if (Utils.isNull(r)) {
            return;
        }
        r.removeEventListener(CoreUI.RescaleEventType.Rescale, this._rescaleHandler, false);
        r.removeEventListener(CoreUI.RescaleEventType.Start, this._rescaleStartHandler, false);
        r.removeEventListener(CoreUI.RescaleEventType.End, this._rescaleEndHandler, false);
        r.remove();
        this._rescaler = null;
    }
    //#endregion
    _setup(metadata = this.metadata) {
        this.setAttribute("css-class", "{{ this.metadata && this.metadata.headCell && this.metadata.headCell.cssClass || [] }}");
        this.setAttribute("css", "{{ this.metadata && this.metadata.headCell && this.metadata.headCell.css }}");
        const truncate = !!(metadata.headCell?.textEllipsis);
        const cssClass = truncate ? ['text-truncate'] : [];
        // alignment
        switch (metadata.headCell?.verticalAlign?.toLowerCase()) {
            case 'top':
                Utils.addClass(this, 'headcell-top');
                break;
            case 'bottom':
                Utils.addClass(this, 'headcell-bottom');
                break;
            case 'middle':
                Utils.addClass(this, 'headcell-middle');
                break;
        }
        switch (metadata.headCell?.horizontalAlign?.toLowerCase()) {
            // headcell display is grid: set h-alignment at content-level
            case 'left':
                cssClass.push('text-left');
                break;
            case 'right':
                cssClass.push('text-right');
                break;
            case 'center':
                cssClass.push('text-center');
                break;
        }
        // basic content
        this.removeAttribute('content');
        const css = !Utils.isNullOrEmpty(cssClass) ? ` class="${cssClass.join(' ')}"` : '';
        const headContent = metadata.headCell?.name ?? metadata.prop;
        this.innerHTML = `<div${css}>${headContent}</div>`;
        if (metadata.isSortable) {
            this._disposeSortButton();
            const btn = this._sortButton = this._setupSortButton();
            this._updateSortButtonIconGlyph(btn);
            this.appendChild(btn);
        }
        if (metadata.isRescalable) {
            this._disposeRescaleContainer();
            const cnt = this._rescaleContainer = this._setupRescaleContainer();
            this.appendChild(cnt);
        }
        if (metadata.isTogglable) {
            // TODO: add context menu actions (hide, filter)
        }
    }
    //#region balloon
    _normalizeTooltip() {
        const metadata = this.metadata.headCell?.tooltip || false;
        if (typeof metadata === 'object') {
            return metadata;
        }
        return { type: metadata };
    }
    _ensureBalloon() {
        var innerText, tooltip;
        const noBalloon = ((tooltip = this._normalizeTooltip()).type === false)
            || Utils.isNullOrEmpty(innerText = this.metadata.headCell?.description);
        // balloon
        if (Utils.isNull(this._balloon) && !noBalloon) {
            let balloon = new UI.PacemBalloonElement();
            balloon.options = {
                behavior: UI.BalloonBehavior.Tooltip,
                trigger: tooltip.trigger || UI.BalloonTrigger.Hover,
                position: tooltip.position || UI.BalloonPosition.Top,
                hoverDelay: 200, hoverTimeout: 50,
                align: tooltip.align || UI.BalloonAlignment.Auto,
            };
            Utils.addClass(balloon, PCSS + '-headcell-tooltip');
            var shell = CustomElementUtils.findAncestorShell(this);
            shell.appendChild(this._balloon = balloon);
        }
        const balloon = this._balloon;
        if (!Utils.isNull(balloon)) {
            balloon.target = this;
            if (!(balloon.disabled = noBalloon)) {
                const content = innerText || '';
                switch (tooltip.type) {
                    case 'md':
                    case 'markdown':
                        balloon.innerHTML = this._md.toHtml(content);
                        break;
                    case 'html':
                        balloon.innerHTML = content;
                        break;
                    default:
                        balloon.innerText = content;
                        break;
                }
            }
        }
    }
    _disposeBalloon() {
        if (!Utils.isNull(this._balloon)) {
            this._balloon.remove();
            this._balloon = null;
        }
    }
};
PacemHeadCellElement = __decorate([
    CustomElement({ tagName: P + '-headcell' })
], PacemHeadCellElement);
export { PacemHeadCellElement };
